// set and shop scan
import assignPhysician from './sales-order/set-and-shop-scan/assign-physician'
import checkCustomerImages from './sales-order/set-and-shop-scan/check-customer-images'
import checkImages from './sales-order/set-and-shop-scan/check-images'
import checkImagesAndScans from './sales-order/set-and-shop-scan/check-images-and-scans'
import checkImagesAndScansRefinement from './sales-order/set-and-shop-scan/check-images-and-scans-refinement'
import checkImagesPost from './sales-order/set-and-shop-scan/check-images-post'
import checkImprintVisually from './sales-order/set-and-shop-scan/check-imprints-visually'
import checkScans from './sales-order/set-and-shop-scan/check-scans'
import confirmTreatmentPlanDone from './sales-order/set-and-shop-scan/confirm-treatment-plan-done'
import clarifyRemarks from './sales-order/set-and-shop-scan/clarify-remarks'
import createTreatmentPlan from './sales-order/set-and-shop-scan/create-treatment-plan'
import createTreatmentPlanExternal from './sales-order/set-and-shop-scan/create-treatment-plan-external'
import createTreatmentPlanExternalPlaner from './sales-order/set-and-shop-scan/create-treatment-plan-external-planer'
import createExternalTreatmentPlanVisualization from './sales-order/set-and-shop-scan/create-external-treatment-plan-visualization'
import checkTreatability from './sales-order/set-and-shop-scan/check-treatability'
import createTreatmentQuotation from './sales-order/set-and-shop-scan/create-treatment-quotation'
import createRefinementPlan from './sales-order/set-and-shop-scan/create-refinement-plan'
import createRefinementPlanExternal from './sales-order/set-and-shop-scan/create-refinement-plan-external'
import createRefinementQuotation from './sales-order/set-and-shop-scan/create-refinement-quotation'
import doSepaPayment from './sales-order/set-and-shop-scan/do-sepa-payment'
import enterPhysicianFeedback from './sales-order/set-and-shop-scan/enter-physician-feedback'
import manuallyCheckImageAvailability from './sales-order/set-and-shop-scan/manually-check-image-availability'
import orderAligner from './sales-order/set-and-shop-scan/order-aligner'
import refund from './sales-order/set-and-shop-scan/refund'
import provideTreatmentSetup from './sales-order/set-and-shop-scan/provide-treatment-setup'
import provideRefinementSetup from './sales-order/set-and-shop-scan/provide-refinement-setup'
import reviewTreatmentPlan from './sales-order/set-and-shop-scan/review-treatment-plan'
import reviewRefinementPlan from './sales-order/set-and-shop-scan/review-refinement-plan'
import reviewTreatmentPlanInternal from './sales-order/set-and-shop-scan/review-treatment-plan-internal'
import scanImprints from './sales-order/set-and-shop-scan/scan-imprints'
import sendTreatmentQuotationReminderWhatsApp1 from './sales-order/set-and-shop-scan/send-treatment-quoation-reminder-whats-app-1'
import sendTreatmentQuotationReminderWhatsApp2 from './sales-order/set-and-shop-scan/send-treatment-quoation-reminder-whats-app-2'
import shipSet from './sales-order/set-and-shop-scan/ship-set'
import treatmentQuotationCreated from './sales-order/set-and-shop-scan/treatment-quotation-created'
import treatmentQuotationCreatedWhatsApp from './sales-order/set-and-shop-scan/treatment-quotation-created-whats-app'
import treatmentQuotationFollowUpCall1 from './sales-order/set-and-shop-scan/treatment-quotation-follow-up-call-1'
import treatmentQuotationFollowUpCall2 from './sales-order/set-and-shop-scan/treatment-quotation-follow-up-call-2'
import uploadTreatmentPlanFiles from './sales-order/set-and-shop-scan/upload-treatment-plan-files'
import visualizationCheck from './sales-order/set-and-shop-scan/visualization-check'
import uploadCase from './sales-order/set-and-shop-scan/upload-case'
import validateCannotBeTreated from './sales-order/set-and-shop-scan/validate-cannot-be-treated'
import clarifyPreTreatment from './sales-order/set-and-shop-scan/clarify-pre-treatment'
import preTreatmentCheck from './sales-order/set-and-shop-scan/pre-treatment-check'
import badImprintPatientCall from './sales-order/set-and-shop-scan/bad_imprint_patient_call'
import makeCustomerAppointment from './sales-order/set-and-shop-scan/make-customer-appointment'
import makeNewCustomerAppointment from './sales-order/set-and-shop-scan/make-new-customer-appointment'
import prepareTreatmentFiles from './sales-order/set-and-shop-scan/prepare-treatment-files'
// check in
import appointmentReminderCall from './sales-order/check-in/appointment-reminder-call'
import checkId from './sales-order/check-in/check-id'
import completeAnamnesis from './sales-order/check-in/complete-anamnesis'
import validateAppointment from './sales-order/check-in/validate-appointment'
import makeNewCustomerScanAppointment from './sales-order/check-in/make-customer-scan-appointment'
import makeNewCustomerIprAppointment from './sales-order/check-in/make-customer-ipr-appointment'
// treatments
import checkPhotoCheckin from './sales-order/treatment/check-photo-checkin'
import finalCheckPhotoCheckin from './sales-order/treatment/final-check-photo-checkin'
import provideCustomerCommunicationReason from './sales-order/treatment/provide_customer_communication_reason'
import clarifyRefinement from './sales-order/treatment/clarify-refinement'
import providePhysicianRecommendation from './sales-order/treatment/provide_physician_recommendation'
import confirmTreatmentPayments from './sales-order/treatment/confirm-treatment-payments'
import followUpCall from './sales-order/treatment/follow-up-call'
import refinementClarificationCall from './sales-order/treatment/refinement-clarification-call'
import printModels from './sales-order/treatment/print-models'
import printMissingModels from './sales-order/treatment/print-missing-models'
import preCheckPhotoCheckin from './sales-order/treatment/precheck-photo-checkin'
import produceAligner from './sales-order/treatment/produce-aligner'
import productAlignerExternal from './sales-order/treatment/produce-aligner-external'
import provideMovementCertificateNumber from './sales-order/treatment/provide-movement-certificate-number'
import shipAligner from './sales-order/treatment/ship-aligner'
import shipAlignerExternal from './sales-order/treatment/ship-aligner-external'
import thermoForm from './sales-order/treatment/thermo-form'
import uploadProductionFiles from './sales-order/treatment/upload-production-files'
import forwardImagesToPhysician from './sales-order/treatment/forward-images-to-physician'
import markingModels from './sales-order/treatment/marking-models'
import makeCustomerIprAppointment from './sales-order/treatment/make-customer-ipr-appointment'
import nesting from './sales-order/treatment/nesting'
import nestMissingModels from './sales-order/treatment/nest-missing-models'
import createInvoiceCorrection from './sales-order/treatment/create-invoice-correction'
import printCaseCard from './sales-order/treatment/print-case-card'
import reduceEnamel from './sales-order/treatment/reduce-enamel'
import startSorting from './sales-order/treatment/start-sorting'
import sortingModels from './sales-order/treatment/sorting-models'

// aligner reproduction
import chooseAligner from './sales-order/aligner-reproduction/choose-aligner'
import produceMissingAlignerExternal from './sales-order/aligner-reproduction/produce-missing-aligner-external'

// retainer
import produceRetainer from './sales-order/retainer/produce-retainer'
import produceRetainerExternal from './sales-order/retainer/produce-retainer-external'
import shipRetainerExternal from './sales-order/retainer/ship-retainer-external'
import shipRetainer from './sales-order/retainer/ship-retainer'
import orderRetainer from './sales-order/retainer/order-retainer'

import { defaultUI } from './sales-order/default-task-definition'
// in shop scan
import consultCustomer from './sales-order/in-shop-scan/consult-customer'
import enterDOB from './sales-order/in-shop-scan/enter-dob'
import medicalCheck from './sales-order/in-shop-scan/medical-check'
import rescan from './sales-order/in-shop-scan/rescan'
import refinementMedicalCheck from './sales-order/in-shop-scan/refinement-medical-check'
import medicalCheckWithPretreatment from './sales-order/in-shop-scan/medical-check-with-pretreatment'
import medicalAssessment from './sales-order/in-shop-scan/medical-assessment'
import confirmMedicalCheck from './sales-order/in-shop-scan/confirm-medical-check'
import confirmRefinementMedicalCheck from './sales-order/in-shop-scan/confirm-refinement-medical-check'
import confirmMedicalCheckWithPretreatment from './sales-order/in-shop-scan/confirm-medical-check-with-pretreatment'
import confirmMedicalAssessment from './sales-order/in-shop-scan/confirm-medical-assessment'
import selectRefinementType from './sales-order/in-shop-scan/select-refinement-type'
import scanCustomer from './sales-order/in-shop-scan/scan-customer'
import takePictures from './sales-order/in-shop-scan/take-pictures'
import uploadScans from './sales-order/in-shop-scan/upload-scans'
import uploadCbct from './sales-order/implant-3dscan/upload-cbct'
import uploadScanFilesManually from './sales-order/in-shop-scan/upload-scan-files-manually'
import match3Shape from './sales-order/in-shop-scan/match-3shape'
import validatePreTreatment from './sales-order/in-shop-scan/validate-pretreatment'
import iprClearingUp from './sales-order/in-shop-scan/ipr-clearing-up'
import iprExplanation from './sales-order/in-shop-scan/ipr-explanation'
import manualAddressCheck from './sales-order/in-shop-scan/manual-address-check'
import complexityTreatment from './sales-order/set-and-shop-scan/treatment-plan-complexity-assignment'

// implant 3dscan
import implantMedicalCheck from './sales-order/implant-3dscan/implant-medical-check'
import confirmImplantMedicalCheck from './sales-order/implant-3dscan/confirm-implant-medical-check'

// implant plan
import implantCreateTreatmentPlan from './sales-order/implant-plan/implant-create-treatment-plan'
import implantReviewTreatmentPlan from './sales-order/implant-plan/implant-review-treatment-plan'
import implantCreateTreatmentQuotation from './sales-order/implant-plan/implant-create-treatment-quotation'
import qmReviewTreatmentPlanInternal from './sales-order/implant-plan/qm-review-treatmen-plan-internal'

// implant treatment
import nestingSurgicalGuide from './sales-order/implant-treatment/nesting-surgical-guide'
import packSurgicalGuide from './sales-order/implant-treatment/pack-surgical-guide'
import printSurgicalGuide from './sales-order/implant-treatment/print-surgical-guide'
import shipSurgicalGuide from './sales-order/implant-treatment/ship-surgical-guide'
import fitGuide from './sales-order/implant-treatment/fit-guide'
import markingAndExport from './sales-order/implant-treatment/marking-and-export'
import implantSurgery from './sales-order/implant-treatment/implant-surgery'

//retainer refinement
import prepareRetainerFiles from './sales-order/retainer-refinement/prepare-retainer-files'

// escalation
import callCustomer from './sales-order/escalation/call-customer'
//end of treatment
import endOfTreatmentCall from './sales-order/end-of-treatment/end-of-treatment-call'

// partial refund
import inputRefundData from './sales-order/partial-refund/input-refund-data'
import confirmRefund from './sales-order/partial-refund/confirm-refund'
import clarifyAlignerCheckinComment from './sales-order/treatment/clarify-aligner-checkin-comment'

const taskDefinition = [
    // checkin
    appointmentReminderCall,
    checkId,
    completeAnamnesis,
    validateAppointment,
    makeNewCustomerScanAppointment,
    makeNewCustomerIprAppointment,

    // shop and set
    assignPhysician,
    checkCustomerImages,
    checkImages,
    checkImagesAndScans,
    checkImagesAndScansRefinement,
    checkImagesPost,
    checkImprintVisually,
    checkScans,
    checkTreatability,
    confirmTreatmentPlanDone,
    createTreatmentPlan,
    createTreatmentPlanExternal,
    createTreatmentPlanExternalPlaner,
    createExternalTreatmentPlanVisualization,
    createTreatmentQuotation,
    createRefinementPlan,
    createRefinementPlanExternal,
    createRefinementQuotation,
    clarifyPreTreatment,
    clarifyRemarks,
    doSepaPayment,
    enterPhysicianFeedback,
    manuallyCheckImageAvailability,
    orderAligner,
    refund,
    preTreatmentCheck,
    provideTreatmentSetup,
    provideRefinementSetup,
    reviewTreatmentPlan,
    reviewRefinementPlan,
    reviewTreatmentPlanInternal,
    scanImprints,
    sendTreatmentQuotationReminderWhatsApp1,
    sendTreatmentQuotationReminderWhatsApp2,
    shipSet,
    treatmentQuotationCreated,
    treatmentQuotationCreatedWhatsApp,
    treatmentQuotationFollowUpCall1,
    treatmentQuotationFollowUpCall2,
    uploadCase,
    validateCannotBeTreated,
    uploadTreatmentPlanFiles,
    visualizationCheck,
    badImprintPatientCall,
    complexityTreatment,
    makeCustomerAppointment,
    makeNewCustomerAppointment,
    prepareTreatmentFiles,

    // treatment
    confirmTreatmentPayments,
    checkPhotoCheckin,
    finalCheckPhotoCheckin,
    provideCustomerCommunicationReason,
    clarifyRefinement,
    clarifyAlignerCheckinComment,
    providePhysicianRecommendation,
    followUpCall,
    refinementClarificationCall,
    printModels,
    produceAligner,
    productAlignerExternal,
    provideMovementCertificateNumber,
    shipAligner,
    thermoForm,
    uploadProductionFiles,
    shipAlignerExternal,
    preCheckPhotoCheckin,
    forwardImagesToPhysician,
    createInvoiceCorrection,
    markingModels,
    makeCustomerIprAppointment,
    printCaseCard,
    nesting,
    reduceEnamel,
    printMissingModels,
    nestMissingModels,
    startSorting,
    sortingModels,

    // retainer
    produceRetainer,
    produceRetainerExternal,
    shipRetainerExternal,
    shipRetainer,
    orderRetainer,

    // in shop scan
    consultCustomer,
    enterDOB,
    medicalCheck,
    medicalCheckWithPretreatment,
    medicalAssessment,
    rescan,
    confirmMedicalCheck,
    confirmMedicalCheckWithPretreatment,
    confirmMedicalAssessment,
    confirmRefinementMedicalCheck,
    refinementMedicalCheck,
    selectRefinementType,
    scanCustomer,
    takePictures,
    uploadScans,
    match3Shape,
    uploadCbct,
    uploadScanFilesManually,
    validatePreTreatment,
    iprClearingUp,
    iprExplanation,
    manualAddressCheck,

    // aligner reproduction
    chooseAligner,
    produceMissingAlignerExternal,

    // implant 3dScan
    implantMedicalCheck,
    confirmImplantMedicalCheck,

    // implant plan
    implantCreateTreatmentPlan,
    implantReviewTreatmentPlan,
    implantCreateTreatmentQuotation,
    qmReviewTreatmentPlanInternal,

    // implant treatment
    nestingSurgicalGuide,
    packSurgicalGuide,
    printSurgicalGuide,
    shipSurgicalGuide,
    fitGuide,
    markingAndExport,
    implantSurgery,

    // retainer refinement
    prepareRetainerFiles,

    // escalation
    callCustomer,

    //partial refund
    inputRefundData,
    confirmRefund,

    //end of treatment
    endOfTreatmentCall,
]

export const getUIDefinitionByStateName = stateName => {
    for (let index = 0; index < taskDefinition.length; index++) {
        const uiDefinition = taskDefinition[index]
        if (!uiDefinition.stateNameList) {
            continue
        }

        if (uiDefinition.stateNameList.indexOf(stateName) !== -1) {
            return uiDefinition
        }
    }
    return {}
}

export const getUIDefinitionByTaskName = taskName => {
    for (let index = 0; index < taskDefinition.length; index++) {
        const uiDefinition = taskDefinition[index]
        if (uiDefinition.taskName === taskName) {
            return uiDefinition
        }
    }
    return defaultUI
}



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/ui-definition.js